// StudentController.js
import BaseController from "src/controller/BaseController.js";
import ApiUrls from "src/routes/api";
import RestApiClient from "src/utils/RestApiClient";

const api = new RestApiClient();

class Report extends BaseController {
  _list = ApiUrls.report.index;
  _post = ApiUrls.report.create;

  async student(student_id, query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.report.student(student_id) + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async studentWeeklyReport(query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.report.studentWeeklyReport + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async teacherWorkReport(query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.report.teacherWorkReport + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async teacherWorkReportAdmin(query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.report.teacherWorkReportAdmin + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export default new Report();
